import { useCallback, useState } from 'react';

import { mfaService } from '@gtintel/signin/services/mfa.service';
import { ApiError } from '@gtintel/signin/types/api.types';
import { MFAVerifyRequest, MFAVerifyResponse } from '@gtintel/signin/types/mfa.types';

export const useMFA = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const verifyMFA = useCallback(async (data: MFAVerifyRequest): Promise<MFAVerifyResponse> => {
    setLoading(true);
    setError(null);

    try {
      const response = await mfaService.verifyMFA(data);
      return response;
    } catch (err) {
      const apiError = err as ApiError;
      setError(apiError.error || 'MFA verification failed');
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  const sendSMS = useCallback(async (temporaryToken: string) => {
    setLoading(true);
    setError(null);

    try {
      const response = await mfaService.sendSMS(temporaryToken);
      return response;
    } catch (err) {
      const apiError = err as ApiError;
      setError(apiError.error || 'Failed to send SMS');
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  const clearError = useCallback(() => {
    setError(null);
  }, []);

  return {
    verifyMFA,
    sendSMS,
    loading,
    error,
    clearError,
  };
};
